import { Status, StatusPL } from '../api/services/orders/types.ts'

export const convertToFullDate = (date: string) => {
  return new Date(date)
}

export const convertToShortDate = (date: string) => {
  const newDate = new Date(date)
  const day = newDate.getDate()
  const month = newDate.getMonth() + 1
  const year = newDate.getFullYear()

  return `${year}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day}`
}

export const convertToShortDateFromSeconds = (timestamp: number) => {
  const date = new Date(timestamp * 1000)
  return date.toISOString().split('T')[0]
}

export const convertOrderStatus = (status: Status) => {
  switch (status) {
    case 'not_paid':
      return 'Nie zapłacone'
    case 'waiting_for_realization':
      return 'Zapłacone / Oczekuje na realizację'
    case 'change_requested':
      return 'Zmiany w ankiecie'
    case 'in_progress':
      return 'Zaplanowano udostępnienie'
    case 'done':
      return 'Zakończone'
    case 'canceled':
      return 'Anulowane'
    default:
      return 'Nie określony'
  }
}

export const convertOrderStatusFromPL = (
  status: StatusPL | 'Wszystkie' | null
): Status | undefined => {
  switch (status) {
    case convertOrderStatus('not_paid'):
      return 'not_paid'
    case convertOrderStatus('waiting_for_realization'):
      return 'waiting_for_realization'
    case convertOrderStatus('change_requested'):
      return 'change_requested'
    case convertOrderStatus('in_progress'):
      return 'in_progress'
    case convertOrderStatus('done'):
      return 'done'
    case convertOrderStatus('canceled'):
      return 'canceled'
    case 'Wszystkie':
      return undefined
    default:
      return undefined
  }
}

export const convertOrderGoal = (goal: string) => {
  switch (goal) {
    case 'weight_reduction':
      return 'Redukcja wagi'
    case 'weight_maintenance':
      return 'Utrzymanie wagi'
    case 'weight_gain':
      return 'Wzrost wagi'
    default:
      return 'Nie określony'
  }
}
